
import React, { useEffect, useState } from 'react';
import EmployeeSelector from "../../components-user/news/EmployeeSelector";
import { MDBInput, MDBCheckbox, MDBBtn, MDBRow, MDBCol, MDBTypography, MDBInputGroup, MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter, MDBChip, MDBCard, MDBCardBody, MDBCardTitle, MDBFile, MDBSpinner, MDBIcon } from 'mdb-react-ui-kit';
import ReactCountryFlag from "react-country-flag";
import { useTranslation } from "react-i18next";
import { Editor } from 'react-draft-wysiwyg';
import { ContentState, EditorState, convertFromHTML} from 'draft-js';
import {convertHTMlToRaw} from "../../utils/HTMLDraft";
import { generateClient } from 'aws-amplify/api';
import { useNavigate } from "react-router-dom";
import { captureError } from '../../utils/sentryHelpers';


const client = generateClient();

const CreateJobListingPage = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const companyId = window.location.pathname.includes("mycompany")
      ? window.location.pathname.split("/")[2]
      : window.location.pathname.split("/")[3];

      let newsId = window.location.pathname.includes("mycompany")
      ? window.location.pathname.split("/")[4]
      : window.location.pathname.split("/")[5];

      newsId = newsId === "create" ? null : newsId;

    const { t, i18n } = useTranslation();
    const [newsData, setNewsData] = useState({
        name: [],
        content: [],
        image: {},
        file: {},
        cMSJobListingEmployeeId: "",
        conditions: [],
    });

    const getNewsData = async () => {
      try {
        const newsData = await client.graphql({
          variables: { id: newsId },
          query: /* GraphQL */ `
          query GetCMSJobListing($id: ID!) {
            getCMSJobListing(id: $id) {
              id
              company {
                id
                name
                status
                createdAt
                companyAdminId
              }
              employee {
                id
                contact {
                  email
                  phone
                  mobile
                  fax
                  address {
                    street
                    streetNumber
                    company
                    zip
                    city
                    countryCode
                  }
                }
                user {
                  id
                  email
                  firstName
                  middleName
                  lastName
                  salutation
                  title
                  status
                  createdAt

                } 
              }
              name {
                language
                text
              }
              image {
                fileName
                alt
              }
              previewImage {
                fileName
                alt
              }
              content {
                language
                text
              }
              file {
                url
                s3Path
                fileName
                type
                name
              }
              conditions {
                name
                accepted
              }
              status
              createdAt
              updatedAt
              companyJobsId
              cMSJobListingEmployeeId
              owner
              __typename
            }
          }
        `,
        });
        console.log(newsData);
       
        return {
          ...newsData.data.getCMSJobListing,
          topics: newsData.data.getCMSJobListing.topics?.items?.map(topic => topic.topicId) || []};
      } catch (error) {
        captureError(error, {
          feature: 'recruiting',
          operation: 'get-job-listing-data',
          consoleMessage: 'Error getting news data:',
          context: { newsId }
        });
        console.warn("Error getting news data", error);
      }
    };

  const intialLoadNews = async () => {
    console.log("loading news");
    setIsLoading(true);
    const dbNews = await getNewsData();
    setNewsData(dbNews);
    if(dbNews.content) {
      const deContent = dbNews.content.find(c => c.language === "de")?.text;
      const enContent = dbNews.content.find(c => c.language === "en")?.text;
      setEditorState({
        de: deContent ? EditorState.createWithContent(
                        ContentState.createFromBlockArray(
                          convertFromHTML(deContent)
                        )
                      ) : EditorState.createEmpty(),
        en: enContent ? EditorState.createWithContent(
                        ContentState.createFromBlockArray(
                          convertFromHTML(enContent)
                        )
                      ) : EditorState.createEmpty(),
      });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    console.log("newsId", newsId, "companyId", companyId)
    if (!companyId) {
      console.warn("No company id provided");
      return;
    } else if (!newsId) {
      console.log("No lecture id provided");
      return;
    } else {
      intialLoadNews();
    }
  }, []);

 

  const [validationErrors, setValidationErrors] = useState([]);

  
  const validateNews = () => {
    const errors = [];
    if (newsData.name.length !== 2) {
      errors.push(t("Please enter a title in both languages"));
    }
    // if(newsData.content.find(t => t.language === "de")?.text?.length < 1000 || newsData.content.find(t => t.language === "en")?.text?.length < 1000) {
    //   errors.push(t("The content must not be longer than 1000 characters"));
    // }
    if(newsData.content.length !== 2) {
      errors.push(t("Please enter content in both languages"));
    }
    if(!newsData.cMSJobListingEmployeeId) {
      errors.push(t("Please select an employee"));
    }
    if(!newsData.image?.fileName) {
      errors.push(t("Please upload an image"));
    }
    if(newsData.image?.fileName && !newsData.conditions?.find(c => c.name === "image")?.accepted) {
      errors.push(t("Please agree to the image conditions"));
    }
    if(newsData.file?.fileName && !newsData.conditions?.find(c => c.name === "file")?.accepted) {
      errors.push(t("Please agree to the file conditions"));
    }

    setValidationErrors(errors);
    return errors.length === 0;
  }

  const createNews = async () => {
    try {
      if(!validateNews()) {
        return;
      }
      setIsLoading(true);
      const response = await client.graphql({
        query: newsId ? /* GraphQL */ `
        mutation UpdateCMSJobListing($input: UpdateCMSJobListingInput!) {
          updateCMSJobListing(input: $input) {
            id  
          }
        }
        ` : /* GraphQL */ `
        mutation CreateCMSJobListing(
          $input: CreateCMSJobListingInput!
          $condition: ModelCMSJobListingConditionInput
        ) {
          createCMSJobListing(input: $input, condition: $condition) {
              id
            }
          }
        `,
        variables: {
          input: {
            companyJobsId: companyId,
            name: newsData.name,
            content: newsData.content,
            image: newsData.image,
            file: newsData.file,
            cMSJobListingEmployeeId: newsData.cMSJobListingEmployeeId,
            conditions: newsData.conditions,
            ...(newsId ? {} : {status: "created"}),
            ...newsId ? {id: newsId} : {},
          },
        },
      });
      console.log("response", response);
      setTimeout(() => {
        navigate(`/mycompany/${companyId}/recruiting-lectures`);
        setIsLoading(false);
      }, 2000);
    } catch (error) {
      captureError(error, {
        feature: 'recruiting',
        operation: newsId ? 'update-job-listing' : 'create-job-listing',
        consoleMessage: 'Error creating/updating job listing:',
        context: { newsId, companyId }
      });
      setIsLoading(false);
      console.log("error", error);
    }
  };


// Select Employee
const [employee, setEmployee] = useState();
const [selectEmployeeModal, setSelectEmployeeModal] = useState(false);
const toggleSelectEmployeeModal = () => setSelectEmployeeModal(!selectEmployeeModal);

const getEmployee = async () => {
    try {
      const employee = await client.graphql({
        query: /* GraphQL */ `
        query GetEmployee($id: ID!) {
            getEmployee(id: $id) {
              id
              user {
                id
                firstName
                lastName
                title
              }
              image {
                fileName
                alt
              }
            }
          }
        `,
        variables: { id: newsData.cMSJobListingEmployeeId },
      });
      setEmployee(employee.data.getEmployee);
    } catch (error) {
      captureError(error, {
        feature: 'recruiting',
        operation: 'fetch-employee',
        consoleMessage: 'Error on fetching employee:',
        context: { employeeId: newsData.cMSJobListingEmployeeId }
      });
      console.log("error on fetching employee", error);
    }
  };


useEffect(() => {
    if (newsData.cMSJobListingEmployeeId) {
        getEmployee();
    }
}, [newsData.cMSJobListingEmployeeId]);

// Editor
// Editor
const [editorState, setEditorState] = useState({
    de: EditorState.createEmpty(),
    en: EditorState.createEmpty(),
})
const onEditorStateChange = (editorState, language ) => {
  setEditorState(oldState => ({...oldState, [language]: editorState}));
  setNewsData(oldNewsData => ({...oldNewsData, content: [...oldNewsData.content.filter(c => c.language !== language), {language, text: convertHTMlToRaw(editorState)}] }));

} 

// Image and Script

const [isUploadingLectureFiles, setIsUploadingLectureFiles] = useState(false);
const [uploadingLecturesErrors, setUploadingLecturesErrors] = useState(null);

const handleSetFile = (file) => {
  // upload file using mutation: uploadLectureFile(base64FileBuffer: String, companyId: String): LambdaS3Response @function(name: "uploadLectureFiles-${env}")
if(file) {
  try {
    setIsUploadingLectureFiles(true);
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onerror = error => {
    console.log('Error: ', error);
    setUploadingLecturesErrors(error);
  }
  reader.onload = async () => {
   try {
    const base64FileBuffer = reader.result.replace(/^data:.+;base64,/, '');
    const response = await client.graphql({
      query: /* GraphQL */ `
        mutation UploadLectureFile($base64FileBuffer: String!, $companyId: String!) {
          uploadLectureFile(base64FileBuffer: $base64FileBuffer, companyId: $companyId) {
            message
            fileName
          }
        }
      `,
      variables: {
        base64FileBuffer,
        companyId,
      },
    });
    console.log("response upload file", response);
    setNewsData(oldNewsData => ({...oldNewsData, file: {fileName: response.data.uploadLectureFile.fileName, type: "newsFile"}}));
    
   } catch (error) {
    captureError(error, {
      feature: 'recruiting',
      operation: 'upload-job-listing-file',
      consoleMessage: 'Error uploading job listing file:',
      context: { companyId }
    });
    console.log("error", error);
    setIsUploadingLectureFiles(false);
    setUploadingLecturesErrors(error.errors[0].message);
   }
  };

  setIsUploadingLectureFiles(false);
  setUploadingLecturesErrors(null);
  } catch (error) {
    captureError(error, {
      feature: 'recruiting',
      operation: 'upload-job-listing-file-outer',
      consoleMessage: 'Error uploading job listing file (outer):',
      context: { companyId }
    });
    console.log("error", error);
    setIsUploadingLectureFiles(false);
    setUploadingLecturesErrors(error.errors[0].message);
  }
  
}
  
}

const [isUploadingLectureImage, setIsUploadingLectureImage] = useState(false);
const [uploadingLectureImageError, setUploadingLectureImageError] = useState(null);

const handleSetImage = (file) => {
  // upload file using mutation: uploadLectureFile(base64FileBuffer: String, companyId: String): LambdaS3Response @function(name: "uploadLectureFiles-${env}")
  if(file) {
    try {
      setIsUploadingLectureImage(true);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onerror = error => {
      console.log('Error reader: ', error);
      setUploadingLectureImageError(error);
    }
    reader.onload = async () => {
      try {
        console.log(reader.result)
        const base64FileBuffer = reader.result.replace(/^data:.+;base64,/, '');
        const response = await client.graphql({
          query: /* GraphQL */ `
          mutation UploadCompanyImage($imageBuffer: String, $imageType: String) {
            uploadCompanyImage(imageBuffer: $imageBuffer, imageType: $imageType)
          }
        `,
          variables: {
            imageBuffer: base64FileBuffer,
            imageType: "newsImage",
          },
        });
        console.log("response", response);
        const fileName = response.data.uploadCompanyImage.replace(/{|}|fileName=/g, '');
        setNewsData(oldNewsData => ({...oldNewsData, image: {fileName, alt: "Lecture Image"}}));
        
        } catch (error) {
          captureError(error, {
            feature: 'recruiting',
            operation: 'upload-job-listing-image',
            consoleMessage: 'Error uploading job listing image:',
            context: {}
          });
          console.log("error", error);
          setIsUploadingLectureImage(false);
          setUploadingLectureImageError(error.errors[0].message);
        }
    }
    setIsUploadingLectureImage(false);
    setUploadingLectureImageError(null);
    } catch (error) {
      captureError(error, {
        feature: 'recruiting',
        operation: 'upload-job-listing-image-outer',
        consoleMessage: 'Error uploading job listing image (outer):',
        context: {}
      });
      console.log("error", error);
      setIsUploadingLectureImage(false);
      setUploadingLectureImageError(error.errors[0].message);
    }
  }
}


return (
<>
<MDBRow className="h-auto d-flex justify-content-center">
<MDBCol size="12" xl="12" xxl="11">
<MDBCard>
<MDBCardBody className="px-1 px-md-5">
<MDBCardTitle>{t("Create Job Listing")}</MDBCardTitle>



{/* TITEL */}
<MDBRow className="d-flex justify-content-evenly mt-2 mt-xl-4">
    <MDBCol size="12" lg="10" xl="8" xxl="7">
    <hr className="mb-1 mb-xl-2" />
        <div className="mb-2 mb-lg-4">
            <MDBTypography tag="h5">
                {t("Position (max. 60 characters)")}
            </MDBTypography>
            {/* <span className="text-muted">
            {t("The title of the news should clearly convey what it is about and at the same time justify why the topic is interesting and relevant.")}
            </span> */}
        </div>
        <MDBInputGroup className="mb-1" textAfter={<span style={newsData.name?.find((t) => t.language === "de")?.text?.length === 60 ? {color: "red", fontWeight: "bold"} : {}}>{((newsData?.name?.length > 0? newsData.name.find((t) => t.language === "de")?.text: "")?.length || "0") + "/60"}</span>}>
            <div className="input-group-text">
            <ReactCountryFlag
                countryCode="de"
                svg
                style={{
                width: "20px",
                height: "20px",
                }}
                title={i18n.language}
            /> 
            </div>
            <MDBInput
            label={t("Position German")}
            type="text"
            maxLength="60"
            value={newsData?.name?.find((t) => t.language === "de")?.text || ""}
            onChange={(e) => setNewsData({...newsData, name: [{language: "de", text: e.target.value}, ...newsData.name.filter((t) => t.language !== "de")]})}
            />
        </MDBInputGroup>
        <MDBInputGroup className="mb-1" textAfter={<span style={newsData.name?.find((t) => t.language === "en")?.text?.length === 60 ? {color: "red", fontWeight: "bold"} : {}}>{((newsData?.name?.length > 0? newsData.name.find((t) => t.language === "en")?.text: "")?.length || "0") + "/60"}</span>}>
            <div className="input-group-text">
            <ReactCountryFlag
                countryCode="gb"
                svg
                style={{
                width: "20px",
                height: "20px",
                }}
                title={i18n.language}
            />
            </div>
            <input
            className="form-control"
            placeholder={t("Position English")}
            type="text"
            maxLength="60"
            value={newsData?.name?.find((t) => t.language === "en")?.text || ""}
            onChange={(e) => setNewsData({...newsData, name: [{language: "en", text: e.target.value}, ...newsData.name.filter((t) => t.language !== "en")]})}
            
            />
        </MDBInputGroup>
    </MDBCol>
</MDBRow>
{/* TITEL END */}

{/* LECTURE DESCRIPTION */}
<MDBRow className="d-flex justify-content-evenly mt-2 mt-xl-4">
    <MDBCol size="12" lg="10" xl="8" xxl="7">
    <hr className="my-4" />
    <div className="mb-2 mb-lg-4">
        <MDBTypography tag="h5">
        {t("Job description")}
         
        </MDBTypography>
        <span className="text-muted">
            {t("Describe the job in as much detail as possible. Make sure to include the following information: area of responsibility, qualifications, place of work, full-time/part-time, salary range")}
            </span>
    </div>
    <ReactCountryFlag
        countryCode="de"
        svg
        style={{
        width: "20px",
        height: "20px",
        }}
        title={i18n.language}
    /> 
    <Editor
        editorState={editorState["de"]}
        editorClassName="md-textarea form-control"
        onEditorStateChange={e => onEditorStateChange(e, "de")}
        toolbar={{
          options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'emoji', 'image', 'remove', 'history'],
        }}
      />
      <br></br>
      <ReactCountryFlag
        countryCode="gb"
        svg
        style={{
        width: "20px",
        height: "20px",
        }}
        title={i18n.language}
    />
    <Editor
        editorState={editorState["en"]}
        editorClassName="md-textarea form-control"
        onEditorStateChange={e => onEditorStateChange(e, "en")}
        toolbar={{
          options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'emoji', 'image', 'remove', 'history'],
        }}
      />
    </MDBCol>
</MDBRow>
{/* LECTURE DESCRIPTION END */}

{/* LECTURE IMAGE */}
<MDBRow className="d-flex justify-content-evenly">
  <MDBCol size="12" lg="10" xl="8" xxl="7">
  <hr className="my-4" />
    <div className="mb-2 mb-lg-4">
      <MDBTypography tag="h5">
      {t("Image")}
      </MDBTypography>
      <span className="text-muted" style={{fontSize: "smaller"}}>{t("Recommended format: 16:9")}</span>
    </div>
    <div className="w-100 text-center mb-2 mb-lg-4">
    <img
      src={newsData?.image?.fileName ? 
      "https://iec-cp-public.s3.eu-central-1.amazonaws.com/newsImages/" + newsData?.image.fileName: "hhttps://placehold.co/600x400"}
      className="img-thumbnail"
      style={{ height: "300px", maxWidth: "100%", width: "auto", aspectRatio: "16 / 9" , objectFit: "cover" }}
      alt='...' />
    </div>
    <MDBFile id='fileDE' onChange={e => handleSetImage(e.target.files[0])} />
    
    
   
    <div className="mt-3">
      <MDBCheckbox
        name="image-condition"
        id="image-condition"
        label={t("I agree that the image will be made public and we have the rights to use the image.")}
        checked={newsData?.conditions?.findIndex(c => c.name === "image") > -1 ? newsData?.conditions[newsData?.conditions?.findIndex(c => c.name === "image")].accepted : false}
        onChange={(e) => {setNewsData(oldNewsData => ({...oldNewsData, conditions: [{name: "image", accepted: e.target.checked}, ...oldNewsData.conditions?.filter(c => c.name !== "image")]}))}}
      />
    </div>
  </MDBCol>
 
</MDBRow>
{/* LECTURE IMAGE END */}



{/* Employee */}
<MDBRow className="d-flex justify-content-evenly mt-2 mt-xl-4">
    <MDBCol size="12" lg="10" xl="8" xxl="7">
    <hr className="my-4" />
        <div className="mb-2 mb-lg-4">
            <MDBTypography tag="h5">
            {t("Select contact person")}
            </MDBTypography>
            <span className="text-muted">
            {t("Choose a contact person who interested parties can contact regarding the job")}
            </span>
        </div>
        <div className="w-100 text-center">
        <MDBBtn onClick={() => toggleSelectEmployeeModal()} color="primary" outline>
            {t("Select employee")}
        </MDBBtn>
        {employee && (
          <div className="d-flex gap-4 align-items-center">
                  {employee.image?.fileName ? (
                    <img
                      src={`https://iec-cp-public.s3.eu-central-1.amazonaws.com/userImages/${employee.image.fileName}`}
                      className="rounded-circle border"
                      style={{
                        height: "50px",
                        width: "50px",
                        objectFit: "cover",
                      }}
                      alt={employee.image.alt}
                    />
                  ) : (
                    <MDBIcon
                      className="rounded-circle border"
                      style={{
                        height: "50px",
                        width: "50px",
                        textAlign: "center",
                        paddingTop: "12px",
                        fontSize: "20px",
                      }}
                      fas
                      icon="user-alt"
                    />
                  )}
                  <div>
                    <h6>{`${employee.user?.title ? employee.user?.title + " ": ""}${employee.user?.firstName} ${employee.user?.middleName || ""} ${employee.user?.lastName}`}</h6>
                    <span>{employee.department?.items?.[0]?.department.name[0].text}</span>
                  </div>
                </div>
        )}
      </div>
    </MDBCol>
</MDBRow>
{/* Employee END */}
<hr className="my-4" />
<MDBRow className="d-flex justify-content-evenly">
<MDBCol size="12" lg="10" xl="8" xxl="7">
{validationErrors.length > 0 && (
  <div className="alert alert-danger" role="alert">
    {validationErrors.map((error) => (
      <p key={error}>{error}</p>
    ))}
  </div>
)}
{
  isLoading ? (
    <div className="text-center">
      <MDBSpinner grow color="primary" />
    </div>
  ) : (
    <MDBBtn color="primary" className="w-100" onClick={() => createNews()}>{newsId ? t("Update") : t("Create")}</MDBBtn>
  )
}

</MDBCol>
</MDBRow>

</MDBCardBody>
</MDBCard>
</MDBCol>
</MDBRow>


<MDBModal open={selectEmployeeModal} onClose={() => setSelectEmployeeModal(false)} staticBackdrop>
  <MDBModalDialog centered size="xl">
      <MDBModalContent >
          <MDBModalHeader>
              <MDBModalTitle>{t("Select employee")}</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={toggleSelectEmployeeModal}></MDBBtn>
          </MDBModalHeader>
          <MDBModalBody>
              <EmployeeSelector
              companyId={companyId}
              selectedEmployees={newsData.cMSJobListingEmployeeId ? [newsData.cMSJobListingEmployeeId]: []}
              setSelectedEmployees={(employees) => setNewsData({...newsData, cMSJobListingEmployeeId: employees[0]})}
              maxSelect={1}
              />
          </MDBModalBody>
          <MDBModalFooter>
              <MDBBtn color="secondary" onClick={toggleSelectEmployeeModal}>{t("Close")}</MDBBtn>
          </MDBModalFooter>
      </MDBModalContent>
  </MDBModalDialog>
</MDBModal>

</>
);
};

export default CreateJobListingPage;
